import { Box, styled, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const StyledCheckIcon = styled(CheckCircleIcon)(({ theme }) => ({
  width: theme.spacing(1.5),
  height: theme.spacing(1.5),
  color: theme.palette.grey[50],
}));

export const StyledWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(0.5),
  cursor: 'pointer',
  borderBottom: `1px dashed ${theme.palette.grey[50]}`,
}));

export const StyledStack = styled(Box)({
  display: 'inline-flex',
});

const BaseFontSize = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  lineHeight: theme.spacing(2.75),
}));

export const StyledTypography = styled(BaseFontSize)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  color: theme.palette.grey[50],
}));

export const StyledPlusText = styled(BaseFontSize)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 900,
  color: theme.palette.secondary.dark,
}));

export const StyledPlusSign = styled(StyledPlusText)({});
StyledPlusSign.defaultProps = {
  variant: 'caption',
};
